import { createBlurMarker } from 'app/core/markers/models';
import { Capabilities } from 'app/utils/Capabilities';
import { InsertConvex } from './InsertConvex';
export const InsertBlur = (defaults) => {
    const createMarker = (point) => {
        const props = Object.assign(Object.assign({}, defaults), { x: point.x, y: point.y });
        if (!Capabilities.shared.isMobileDevice) {
            props.locked = configGet('autolockBlurs', true);
        }
        return createBlurMarker(props);
    };
    return InsertConvex(createMarker);
};
